<template>
  <div>
    <div class="refund" v-if="refundPrice > 0">
      <img :src="require('@/assets/images/refund.png')"/>
    </div>
    <div class="py-2" v-if="item.length === 0">
      <img :src="require('@/assets/images/empty.png')" height="200" width="100%"/>
    </div>
    <v-card elevation="0" outlined class="pa-2 ma-3" v-if="allPrice >0 ">
      <span class="size-13 py-1">合同总额： {{allPrice}}， 收款：{{item | fmPrice}}，退款：{{item | fmPrice | fmRunPrice(that)}}</span>
    </v-card>
    <div class="pd-c-12" v-for="(res, ridx) in item" :key="ridx">
      <v-row v-if="res.order !== null">
        <v-col cols="12" class="size-13 py-1">
          审核状态：
          <v-chip class="mr-2 px-1" dark x-small label :color="res.order.auditStatus | formatAuditColor">
            {{res.order.auditStatusVal}}
          </v-chip>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' class="size-13 py-1">
          本次提成：<span class="grey--text text--darken-1">{{res.ratioPrice}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' class="size-13 py-1">
          支付方式：<span class="grey--text text--darken-1">{{res.payTypeDic.name}}</span>
        </v-col>
         <v-col :cols="$isMobile ? 12 : 12" :md='mini ? 6 : 4' class="size-13 py-1">
          汇款单位：<span class="grey--text text--darken-1">{{res.returnFrom}}</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="$isMobile ? 12 : 12" :md='mini ? 3 : 4' class="size-13 py-1">
          回款编号：<span class="grey--text text--darken-1">{{res.returnNumber}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' class="size-13 py-1">
          回款类型：<span class="grey--text text--darken-1">{{res.returnTypeDic.name}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 6: 4' class="size-13 py-1">
          回款状态：<span class="grey--text text--darken-1">{{res.returnStateDic.name}}</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' class="size-13 py-1">
          回款金额：<span class="grey--text text--darken-1">{{res.money}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' class="size-13 py-1">
          回款日期：<span class="grey--text text--darken-1">{{res.returnTime | formatDay}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 12 : 12" :md='mini ? 6 : 4' class="size-13 py-1">
          收款账户：<span class="grey--text text--darken-1">{{res.returnAccountDic.name}}</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="size-13 py-1">
          备注信息：<span class="grey--text text--darken-1">{{res.remark}}</span>
        </v-col>
      </v-row>
      <v-divider class="mt-5" v-if="ridx + 1 < item.length"></v-divider>
     </div>
  </div>
</template>

<script>
  export default {
    name: 'ReturnedDetail',
    components: {
    },
    filters: {
      fmPrice (item) {
        let money = 0
        item.forEach(el => {
          if (el.order.auditStatus === 1) {
            money += el.money
          }
        })
        return money
      },
      fmRunPrice (money, this_) {
        this_.refundPrice = money - this_.surRefundPrice
        return this_.refundPrice
      }
    },
    props: {
      item: {
        type: Array,
        default: () => ([])
      },
      allPrice: {
        type: Number,
        default: 0
      },
      surRefundPrice: {
        type: Number,
        default: 0
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        that: this,
        refundPrice: ''
      }
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
.refund {
  position: absolute;
  z-index: 1;
  left: 250px;
  top: 80px;
  img{
    width: 120px;
    -moz-transform: rotate(-30deg);
    -webkit-transform: rotate(-30deg);
  }
}
</style>
